interface ScrollFadeOverlayProps {
  canScrollUp: boolean;
  canScrollDown: boolean;
  children: React.ReactNode;
}

export const ScrollFadeOverlay = ({ canScrollUp, canScrollDown, children }: ScrollFadeOverlayProps) => (
  <div className='tw-relative'>
    {canScrollUp && (
      <div
        className='tw-pointer-events-none tw-absolute tw-left-0 tw-right-0 tw-top-0 tw-z-10 tw-h-6'
        style={{ background: "linear-gradient(to bottom, white, transparent)" }}
      />
    )}
    {canScrollDown && (
      <div
        className='tw-pointer-events-none tw-absolute tw-left-0 tw-right-0 tw-bottom-0 tw-z-10 tw-h-6'
        style={{ background: "linear-gradient(to top, white, transparent)" }}
      />
    )}
    {children}
  </div>
);
